/* globals google */

import { better_text, title_case } from '@massimo-cassandro/js-utilities';

export default function () {

  const map_container = $('#map'),

    pagedata = $('#pagedata').data(),
    brand_suffix = +pagedata.b === 2? 'vv' : (+pagedata.b === 3? 'bv' : 'bn'),

    map_icon = '/imgs/map-pin-' + brand_suffix + '.png',

    punti_vendita_mappa = pagedata.pv.filter(item => {
      return item.lat && item.lng;
    }),

    build_map = () => {

      let map,
        infoWindow = new google.maps.InfoWindow({
          maxWidth: 400
        }),

        setMarkers = () => {

          /*

        'puntiVendita' => array(
          array(
            'agenzia' => 'Viaggi & Vacanze',
            'indirizzo' => 'Via Monte Rosa',
            'cap' => '00100',
            'comune' => 'Milano',
            'localita' => null,
            'provincia' => 'MI',
            'nazione'  => 'IT',
            'telefono' => '0213456789',
            'email' => 'viaggievacanze@bluvacanze.it',
            'pec' => null,
            'fax' => null,
            'lat' => '45.395771',
            'lng' => '8.918373',
            'orari' => $orari
          ),

        )
      */

          let creaInfoWindow = (marker, pv) => {
              google.maps.event.addListener(marker, 'click', function() {
                let infoWindow_content = '';

                infoWindow_content += '<div class="iw iw-name">' + pv.agenzia + '</div>'+
            '<div class="iw iw-info">' +
              better_text(title_case(pv.indirizzo)) +'<br>' +
              pv.cap + ' ' + better_text(title_case(pv.comune)) +
                better_text(title_case(pv.localita)) +
                (pv.provincia? ' (' + pv.provincia.toUpperCase() + ')': '') + '<br>' +
              ((pv.nazione && pv.nazione.toLowerCase() !== 'it' )? better_text(title_case(pv.nazione)) + '<br>': '' ) +

              '<div class="small mt-1">' +
                '<a href="https://www.google.com/maps/search/?api=1&amp;query=' +
                  encodeURIComponent(
                    (pv.agenzia + ', ' + pv.indirizzo + ' ' + pv.cap + ' ' + pv.comune + ' ' +
                    pv.provincia + ' ' + pv.nazione).replace(/ +/g, ' ')
                  ) + '+@' + pv.lat + ',' + pv.lng + '" target="_blank">' +
                  'Mostra su Google Maps' +
                 '</a>' +
              '</div>' +
            '</div>';

                infoWindow.setContent(infoWindow_content);
                infoWindow.open(map, marker);
              });
            },

            markers= [];

          punti_vendita_mappa.forEach(item => {
            item.lat = +item.lat;
            item.lng = +item.lng;

            let this_marker = new google.maps.Marker({
              position: new google.maps.LatLng(item.lat, item.lng),
              title: item.agenzia, // nome agenzia
              icon: map_icon,
              animation: google.maps.Animation.DROP
            });
            this_marker.setMap(map);
            markers.push(this_marker);

            creaInfoWindow(this_marker, item);

          }); // end punti_vendita_mappa.forEach

          let bounds = new google.maps.LatLngBounds();
          for (let i = 0; i < markers.length; i++) {
            bounds.extend(markers[i].getPosition());
          }

          map.fitBounds(bounds);

          // max zomm
          let mapsIdle = google.maps.event.addListener(map, 'idle', function() {
            //console.log(map.getZoom()); // eslint-disable-line
            if (map.getZoom() > 16) map.setZoom(16);
            google.maps.event.removeListener(mapsIdle);
          });


          //google.maps.event.trigger(markers[0], 'click');
        };

      map = new google.maps.Map(
        map_container[0],
        {
          zoom: 13,
          center: new google.maps.LatLng(punti_vendita_mappa[0].lat, punti_vendita_mappa[0].lng),

          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DEFAULT,
            position: google.maps.ControlPosition.LEFT_BOTTOM
          },

          zoomControl: true,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.LARGE,
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },

          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },

          fullscreenControl: false,
          scaleControl: true,
          rotateControl: true,
          //scrollwheel: true,
          gestureHandling: 'cooperative'
        }
      );

      setMarkers();


      google.maps.event.addDomListener(window, 'resize', function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
      });

    }; // end build_map

  if(punti_vendita_mappa.length) {
    let script = document.createElement('script');

    script.onload = function() {
      build_map();
    };

    const google_api_key = document.currentScript.dataset.apikey;

    script.src = '//maps.googleapis.com/maps/api/js?key=' + google_api_key;
    document.head.appendChild(script);

  } else {
    map_container.remove();
  }
}
